(function () {
  if (window.__klaInit) { if (window.__klaApply) window.__klaApply(); return; }
  window.__klaInit = true;
  var d = document, root = d.documentElement, KEY = 'kla-prefs-v1';
  var st = { fs: 0, hc: 0, links: 0, font: 0, space: 0, still: 0 };
  var LEVELS = [100, 112, 125, 140];
  var CLASSES = ['kla-hc', 'kla-links', 'kla-font', 'kla-space', 'kla-still'];
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  function load() {
    if (inEditor) { try { localStorage.removeItem(KEY); } catch (e) {} return; }
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || '{}');
      for (var k in st) { if (typeof s[k] === 'number') st[k] = s[k]; }
    } catch (e) {}
  }
  function save() {
    if (inEditor) return;
    try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {}
  }

  function apply() {
    if (inEditor) {
      root.removeAttribute('data-kla-fs');
      CLASSES.forEach(function (c) { root.classList.remove(c); });
      return;
    }
    if (st.fs > 0) root.setAttribute('data-kla-fs', st.fs); else root.removeAttribute('data-kla-fs');
    [['hc', 'kla-hc'], ['links', 'kla-links'], ['font', 'kla-font'], ['space', 'kla-space'], ['still', 'kla-still']].forEach(function (p) {
      root.classList.toggle(p[1], !!st[p[0]]);
    });
    Array.prototype.forEach.call(d.querySelectorAll('[data-kla-toggle]'), function (b) {
      b.setAttribute('aria-pressed', st[b.getAttribute('data-kla-toggle')] ? 'true' : 'false');
    });
    var lv = d.querySelector('[data-kla-level]');
    if (lv) lv.textContent = LEVELS[st.fs] + '%';
  }
  window.__klaApply = apply;

  function panel() { return d.getElementById('kla-panel'); }
  function trigger() { return d.querySelector('[data-kla-open]'); }
  function openPanel() {
    var p = panel(), t = trigger();
    if (!p || !t) return;
    p.hidden = false;
    t.setAttribute('aria-expanded', 'true');
    var h = p.querySelector('[data-kla-focus]');
    if (h) h.focus();
  }
  function closePanel(returnFocus) {
    var p = panel(), t = trigger();
    if (!p || !t || p.hidden) return;
    p.hidden = true;
    t.setAttribute('aria-expanded', 'false');
    if (returnFocus) t.focus();
  }

  d.addEventListener('click', function (e) {
    if (inEditor) return;
    var el = e.target.closest ? e.target : null;
    if (!el) return;
    if (el.closest('[data-kla-open]')) {
      var p = panel();
      if (p && !p.hidden) closePanel(false); else openPanel();
      return;
    }
    if (el.closest('[data-kla-close]')) { closePanel(true); return; }
    var tg = el.closest('[data-kla-toggle]');
    if (tg) {
      var k = tg.getAttribute('data-kla-toggle');
      st[k] = st[k] ? 0 : 1;
      save(); apply(); return;
    }
    var fs = el.closest('[data-kla-fs-step]');
    if (fs) {
      var n = st.fs + parseInt(fs.getAttribute('data-kla-fs-step'), 10);
      st.fs = Math.max(0, Math.min(LEVELS.length - 1, n));
      save(); apply(); return;
    }
    if (el.closest('[data-kla-reset]')) {
      for (var key in st) st[key] = 0;
      save(); apply(); return;
    }
    if (!el.closest('.kla-root')) closePanel(false);
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var p = panel();
      if (p && !p.hidden) { closePanel(true); }
    }
  });

  d.addEventListener('shopify:section:load', apply);
  load();
  apply();
})();